var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coins"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.08268 2.78646C9.08268 3.59187 7.25451 4.24479 4.99935 4.24479C2.74419 4.24479 0.916016 3.59187 0.916016 2.78646M9.08268 2.78646C9.08268 1.98104 7.25451 1.32812 4.99935 1.32812C2.74419 1.32812 0.916016 1.98104 0.916016 2.78646M9.08268 2.78646V9.78646C9.08268 10.5919 7.25451 11.2448 4.99935 11.2448C2.74419 11.2448 0.916016 10.5919 0.916016 9.78646V2.78646M9.08268 5.11979C9.08268 5.92521 7.25451 6.57813 4.99935 6.57813C2.74419 6.57813 0.916016 5.92521 0.916016 5.11979M9.08268 7.45313C9.08268 8.25854 7.25451 8.91146 4.99935 8.91146C2.74419 8.91146 0.916016 8.25854 0.916016 7.45313",
    stroke: "white",
    strokeWidth: 1.16667
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditwhite);
export default __webpack_public_path__ + "static/media/creditwhite.6f7fdb979dd831290cf178fe18d4595b.svg";
export { ForwardRef as ReactComponent };